import { clearLocalStorage } from "@faire/help-center-self-serve/utils/localStorage";
import { BackToCta } from "@faire/help-center-utils/components/BackToCta/BackToCta";
import { BackToDestination } from "@faire/help-center-utils/components/BackToCta/types";
import { getUserPhoneNumber } from "@faire/help-center-utils/serialized-data/getUser";
import { Email } from "@faire/web/slate/icons/foundation/Email";
import { Phone } from "@faire/web/slate/icons/foundation/Phone";
import { Flex } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { useScrollToTopOnLoadEffect } from "../../hooks/useScrollToTopEffect";
import { IconWrapper } from "./styles";
export var EmailSubmitted = function EmailSubmitted(_ref) {
  var supportType = _ref.supportType;
  useScrollToTopOnLoadEffect();
  var phoneNumber = getUserPhoneNumber();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconWrapper, null, supportType === "phone" ? ( /*#__PURE__*/React.createElement(Phone, {
    fontSize: "24px"
  })) : ( /*#__PURE__*/React.createElement(Email, {
    fontSize: "24px"
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }), supportType === "phone" ? ( /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionHeaderSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "5BWAy2",
    defaultMessage: [{
      "type": 0,
      "value": "Nous avons reçu votre demande d'appel téléphonique"
    }]
  }))) : ( /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionHeaderSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IMMO+3",
    defaultMessage: [{
      "type": 0,
      "value": "Nous avons reçu votre demande"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), supportType === "phone" ? ( /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "cKiuN1",
    defaultMessage: [{
      "type": 0,
      "value": "Un agent du service client va examiner les détails de votre demande et vous appeler au "
    }, {
      "type": 1,
      "value": "phoneNumber"
    }, {
      "type": 0,
      "value": ". Le temps d'attente moyen est de 3 minutes."
    }],
    values: {
      phoneNumber: phoneNumber
    }
  }))) : ( /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "eGz80J",
    defaultMessage: [{
      "type": 0,
      "value": "Un agent du service client va l'examiner en détail et vous répondre par e-mail dans un délai d'un jour ouvré."
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(BackToCta, {
    destination: BackToDestination.HELP_CENTER,
    onClick: clearLocalStorage
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(BackToCta, {
    variant: "secondary",
    destination: BackToDestination.FAIRE,
    onClick: clearLocalStorage
  })));
};
var ButtonWrapper = styled(Flex).attrs({
  direction: {
    tabletAndAbove: "row",
    mobileAndAbove: "column"
  }
}).withConfig({
  displayName: "EmailSubmitted__ButtonWrapper"
})([""]);